<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mt-2 mb-3">
          <li>
            <router-link to="/setup/team-user" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("setup.label.TeamCode") }}: {{ $route.params.name }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="truncate"
                      size="small"
                      @click.stop="editTUser()"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="warning"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteTicketPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
            <div class="dual-listbox-wrapper">
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.AvailableUsers") }}
                  </h6>
                  <input
                    v-model="searchSource"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredSourceUsers"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedSourceUsers === plan.id ? 'active' : '',
                    ]"
                  >
                      {{ plan.username }}
                  </li>
                </ul>
              </div>
        
              <div class="arrow-buttons">
                <button
                  class="arrow-button"
                  :disabled="!selectedSourceUsers"
                  @click="moveToTarget"
                >
                  <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
                </button>
                <button
                  class="arrow-button"
                  :disabled="!selectedTargetUsers"
                  @click="moveToSource"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                </button>
              </div>
        
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.SelectedUsers") }}
                  </h6>
                  <input
                    v-model="searchTarget"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredTargetUsers"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedTargetUsers === plan.id ? 'active' : '',
                    ]"
                  >
                      {{ plan.username }}
                  </li>
                </ul>
              </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.DeleteTeamUser')"
        :active.sync="deleteTicketPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">Are you sure you want to delete?</div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="deletePopup = false">{{
              $t("setup.label.Cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteTicket()">{{
              $t("setup.label.Confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      data: {},
      users: [],
      id: 0,
      deleteTicketPopup: false,
      usersInit: {},
      selectedSourceUsers: null,
      selectedTargetUsers: null,
      searchSource: "",
      searchTarget: "",
      ticketData: []
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      teamUserById: (state) => state.teams.teamUserById,
    }),
    filteredSourceUsers() {
      if (this.usersInit && this.usersInit.sourceUsers) {
        return this.usersInit.sourceUsers.filter(
          (d) =>
            d.username.toLowerCase().includes(this.searchSource.toLowerCase())
        );
      } else {
        return null;
      }
    },
    filteredTargetUsers() {
      if (this.usersInit && this.usersInit.targetUsers) {
        return this.usersInit.targetUsers.filter(
          (d) =>
            d.username.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    initializeUsers() {
      const availableUsers = (this.ticketData && this.ticketData.availableUsers) || [];
      const selectedUsers = (this.ticketData && this.ticketData.selectedUsers) || [];

      const formattedSelectedUsers = selectedUsers.map(user => ({
        id: user.userId,
        username: user.username
      }));

        if (formattedSelectedUsers && formattedSelectedUsers.length > 0) {

          const targetUsers = formattedSelectedUsers
          const sourceUsers = availableUsers

          this.$set(this, "usersInit", {
            sourceUsers,
            targetUsers,
          });
        } else {
          this.$set(this, "usersInit", {
            sourceUsers: [...availableUsers],
            targetUsers: [],
          });
        }
      this.selectedSourceUsers = null;
      this.selectedTargetUsers = null;
    },
    moveToTarget() {
      if (!this.selectedSourceUsers) return;

      const selectedUser = this.usersInit.sourceUsers.find(
        (e) => e.id === this.selectedSourceUsers
      );

      if (selectedUser) {
        this.usersInit.targetUsers.push(selectedUser);
        this.usersInit.sourceUsers =
          this.usersInit.sourceUsers.filter(
            (e) => e.id !== this.selectedSourceUsers
          );
        this.selectedSourceUsers = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetUsers) return;

      const selectedUser = this.usersInit.targetUsers.find(
        (e) => e.id === this.selectedTargetUsers
      );

      if (selectedUser) {
        this.usersInit.sourceUsers.push(selectedUser);
        this.usersInit.targetUsers =
          this.usersInit.targetUsers.filter(
            (e) => e.id !== this.selectedTargetUsers
          );
        this.selectedTargetUsers = null;
      }
    },
    async getTicketUserByID() {
      try {
        await this.$store.dispatch("teams/setTicketUserById", this.id);
        this.ticketData = this.teamUserById;
        this.initializeUsers()
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async deleteTicket() {
      try {
        this.deleteTicketPopup = false;
        await this.$store.dispatch("teams/deleteTeamUserAction", this.id);
        this.$router.push("/setup/team-user");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editTUser() {
      this.$router.push(`/setup/team-user/editicketuser/${this.id}`);
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getTicketUserByID();
  },
  watch: {},
};
</script>

<style scoped>
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>